export class Log {
    constructor(
      public id: string,
      public category: string,
      public order: number,
      public email: string,
      public userId: string,
      public description: string,
      public debug: string,
      public platform: string,
      public version: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/logs/shared/log.model.ts